// extracted by mini-css-extract-plugin
export default {"input-wrapper":"input_input-wrapper__SToQ7","label":"input_label__im4tM","input":"input_input__kkr8-","input-with-icon":"input_input-with-icon__+AZzG"};